export enum FeedbackType {
    SATISFIED = 'satisfied',
    UNSATISFIED = 'unsatisfied',
    NO_RESPONSE = 'no-response',
}
